export default {
  displayPreloader: false,
};
